export default [
  {
    date: 1497560707005,
    row: 9,
    col: 11,
    segments: [
      [2, 6, 4, 8],
      [4, 8, 8, 8],
      [8, 8, 10, 6],
      [10, 6, 2, 6],
      [6, 6, 6, 2],
      [6, 2, 3, 6],
      [6, 2, 9, 6]
    ]
  },
  {
    date: 1495989478692,
    row: 9,
    col: 11,
    segments: [
      [4, 8, 7, 8],
      [7, 8, 9, 6],
      [4, 8, 2, 6],
      [2, 6, 2, 3],
      [2, 3, 4, 2],
      [4, 2, 8, 2],
      [8, 2, 9, 5],
      [9, 5, 11, 3],
      [11, 3, 11, 8],
      [11, 8, 9, 6],
      [3, 4, 3, 5],
      [3, 5, 4, 5],
      [4, 5, 4, 4],
      [3, 4, 4, 4],
      [3, 7, 5, 6]
    ]
  },
  {
    date: 1495989107604,
    row: 9,
    col: 11,
    segments: [
      [2, 8, 10, 8],
      [2, 8, 2, 4],
      [2, 4, 4, 2],
      [4, 2, 8, 2],
      [8, 2, 10, 4],
      [10, 4, 10, 8],
      [2, 4, 10, 4],
      [5, 8, 5, 6],
      [5, 6, 7, 6],
      [7, 6, 7, 8]
    ]
  },
  {
    date: 1430347120616,
    row: 9,
    col: 11,
    segments: [
      [2, 4, 4, 4],
      [4, 4, 4, 2],
      [4, 2, 6, 2],
      [6, 2, 6, 4],
      [6, 4, 4, 4],
      [6, 4, 8, 4],
      [8, 4, 10, 4],
      [8, 4, 8, 6],
      [8, 6, 6, 6],
      [6, 6, 6, 4],
      [4, 4, 4, 6],
      [4, 6, 6, 6],
      [2, 6, 4, 6],
      [2, 4, 2, 6],
      [8, 6, 10, 6],
      [10, 4, 10, 6],
      [4, 6, 4, 8],
      [4, 8, 6, 8],
      [6, 8, 6, 6]
    ]
  },
  {
    date: 1430347120616,
    row: 9,
    col: 11,
    segments: [
      [4, 5, 3, 4],
      [3, 4, 6, 2],
      [6, 2, 7, 2],
      [7, 2, 7, 3],
      [7, 3, 9, 2],
      [9, 2, 10, 3],
      [10, 3, 10, 7],
      [10, 7, 9, 8],
      [9, 8, 7, 7],
      [7, 7, 7, 8],
      [7, 8, 6, 8],
      [6, 8, 3, 6],
      [3, 6, 4, 5],
      [5, 4, 9, 3],
      [9, 3, 9, 4],
      [9, 4, 5, 4],
      [5, 6, 9, 6],
      [9, 6, 9, 7],
      [9, 7, 5, 6]
    ]
  }
];
